import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInferenceNotification = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2656 6.74756L15.2031 4.68506L17.2656 3.74756L15.2031 2.81006L14.2656 0.747559L13.3281 2.81006L11.2656 3.74756L13.3281 4.68506L14.2656 6.74756Z",
			fill: "url(#paint0_linear_3576_47647)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.2656 11.2471L13.3281 13.3096L11.2656 14.2471L13.3281 15.1846L14.2656 17.2471L15.2031 15.1846L17.2656 14.2471L15.2031 13.3096L14.2656 11.2471Z",
			fill: "url(#paint1_linear_3576_47647)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.63867 7.12231L6.76367 2.99731L4.88867 7.12231L0.763672 8.99731L4.88867 10.8723L6.76367 14.9973L8.63867 10.8723L12.7637 8.99731L8.63867 7.12231ZM7.50617 9.73981L6.76367 11.3748L6.02117 9.73981L4.38617 8.99731L6.02117 8.25481L6.76367 6.61981L7.50617 8.25481L9.14117 8.99731L7.50617 9.73981Z",
			fill: "url(#paint2_linear_3576_47647)"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_3576_47647",
				x1: 11.2656,
				y1: .747559,
				x2: 17.6912,
				y2: 1.24444,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#6565EC" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .185,
						stopColor: "#009EFA"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#00C9A7"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .59,
						stopColor: "#FFC75F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .795,
						stopColor: "#FF8066"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D65DB1"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_3576_47647",
				x1: 11.2656,
				y1: 11.2471,
				x2: 17.6912,
				y2: 11.744,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#6565EC" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .185,
						stopColor: "#009EFA"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#00C9A7"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .59,
						stopColor: "#FFC75F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .795,
						stopColor: "#FF8066"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D65DB1"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_3576_47647",
				x1: .763672,
				y1: 2.99731,
				x2: 13.6148,
				y2: 3.99109,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#6565EC" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .185,
						stopColor: "#009EFA"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .39,
						stopColor: "#00C9A7"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .59,
						stopColor: "#FFC75F"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: .795,
						stopColor: "#FF8066"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#D65DB1"
					})
				]
			})
		] })
	]
});
export { SvgInferenceNotification as ReactComponent };
